export default __webpack_public_path__ + "static/media/EN.02f524ef.svg";